import type { Agents } from "@oneethos/shared"

type AiLoadingIndicatorProps = {
  run?: Agents.IWorkflowRun
}

export const AiLoadingIndicator = ({ run }: AiLoadingIndicatorProps) => {
  return <div className="ai-loading-indicator ai-border rotating ms-2">
    {/* <OEAILogo style={{ height: '1em' }} /> */}
    <a
      href={`https://agents.oneethos.ai/workflows/${run?.data?.workflowId}?run=${run?.data?.id}`}
      target="_blank"
      className="gradient-text text-center"
    >
      AI Review in Progress
    </a>
  </div>
}
